import {FileDeletionInfo, FileOwnerInfo} from "@/models/entities/ModelHelpers";
import {FileStatus, FileFilterCriteria} from "@/utilities/enums/Enums";
import Recipient from "@/models/entities/Recipient";
import RecipientList from "@/models/entities/RecipientList";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default class ProjectFile {
  id: number = -1;
  name: string = '';
  description?: string | null = null;
  type: string = '';
  extension: string = '';
  sizeInBytes: number = 0;
  displaySize: string = '';
  downloadToken: string = '';
  status: FileStatus = FileStatus.pending;
  uploadProgress: number = 0;
  owner: FileOwnerInfo = new FileOwnerInfo();
  deletion: FileDeletionInfo = new FileDeletionInfo();
  uploadedAt: string = getGermanIsoString(); //DateString
  modifiedAt?: string|null = null; //DateString
  activeTicketCount: number = 0;
  uploadTicketGuid: string|null = null;
  messageToCreator: string|null = null;
  filterCriteria: FileFilterCriteria|null = null;
  filterValue: string|null = null;

  //helpers
  file: File|null = null;
  newRecipient?: Recipient|null = null;
  recipients: Array<Recipient> = [];
  recipientLists: Array<RecipientList> = [];
  messageToRecipients: string|null = null;

  constructor(data: Record<string, any> | undefined = undefined) {
    Object.assign(this, data);

    if (!this.newRecipient) {
      this.newRecipient = new Recipient();
    }
  }
}
